import { Api } from 'base'
import Menu from './menu'
import Model from './model'

class MenuApi extends Api {
  collectionName = 'menus'

  async load() {
    let mobile_param = location.hash.split('?').pop()
    let results = await Backend.get(`/menus?${mobile_param}`)
    let menus = results.menus.map(r => new Menu(r))
    // if (App.disableHomeFeed) {
    //   menus = menus.filter(menu => menu.id != 'my_feed')
    // }
    return menus
  }

  async show({ id, page, limit }) {
    let params = { }
    if (page) params.page = page
    if (limit) params.limit = limit
    let result = await Backend.get(`/menus/${id}`, params)
    if (result.menu && result.menu.items) {
      let items = _.compact(result.menu.items.map(r => new Model.fromJSON(r)))
      if (limit) items.push({ totalPages: result.menu.total_pages || 1 })
      return items
    } else
      return []
  }
}

export default new MenuApi
